import {Injectable} from '@angular/core'

import {Observable} from 'rxjs'
import {map} from 'rxjs/operators'

import {Task, TaskService, GetTasksRequest} from '@app/core/services/rest-api'
import {SearchFilter} from '@app/core/services/search/search-filter.interface'
import {
  GenericListService,
  LoadRequest,
  LoadResult,
} from '@app/core/services/generic-list.service'

import {NotificationService} from '@app/core/services/notification.service'
import {LoggerService} from '@app/core/services/logger.service'
import {ContextService} from '@app/core/services/context.service'

@Injectable()
export class TaskListService extends GenericListService<Task> {
  filter: SearchFilter = null

  constructor(
    private taskSvc: TaskService,
    protected notify: NotificationService,
    protected contextSvc: ContextService,
    protected logger: LoggerService,
  ) {
    super(notify, logger)
  }

  retrieve(request: LoadRequest): Observable<LoadResult<Task>> {
    const svcRequest: GetTasksRequest = {
      offset: request.offset,
      results: request.count,
    }

    if (this.filter) {
      svcRequest.search = this.filter.query
      svcRequest.sort = this.filter.sort
      svcRequest.asc = this.filter.asc
    }

    return this.taskSvc.getTasks(svcRequest).pipe(
      map((res) => {
        const result: LoadResult<Task> = {
          total: res.count,
          items: res.results,
        }
        return result
      }),
    )
  }
}
